/* global _ */
import Vue from 'vue'
import Vuex from 'vuex'
import AppModule from './appmodule'
import WebModule from './webmodule'
import Cookie from 'js-cookie'

Vue.use(Vuex)

/**
 * 从 COOKIE 中读取上一次记录的  domainId 
 * 并判断是否存在
 */
const domainIDMemo = Cookie.get('_curdomainid') || 0
const domainList = window.$domainList || []
const currentDomain =
  (domainIDMemo && _.find(domainList, { id: Number(domainIDMemo) })) || domainList[0]
const currentDomainId = (currentDomain && currentDomain.id) || ''

// create a store
const state = {
  mvAddSite: false,
  startValidCrowdForm: false,
  sidebarStatus: false,
  domainList: domainList,
  domainId: currentDomainId,
  currentClusterId: 0,
  dianjingID: 0,
  currentDomain: currentDomain,
  start: '',
  end: '',
  dateAsParam: {
    start: '',
    end: ''
  },
  paramsCrossPage: {
    webOriginview: '',
    webOriginTab: ''
  },
  loading: false,
  tableLoading: false,
  chartLoading: false,
  drawChartabled: true,
  fetchResult: [],
  fetchMultResult: {
    sum: {},
    detail: []
  },
  tableCheckList: [],
  uiError: {
    errMsg: ''
  },
  siteList: [],
  aoTarget: 0
}

// create mutations
const mutations = {
  SET_CLUSTER_ID (state, id) {
    Vue.set(state, 'currentClusterId', id)
  },
  SET_MV_ADDSITE (state, status) {
    Vue.set(state, 'mvAddSite', status)
  },
  SET_START_CROWDVALID (state, status) {
    Vue.set(state, 'startValidCrowdForm', status)
  },
  SET_SIDEBAR_STATUS (state, status) {
    Vue.set(state, 'sidebarStatus', status)
  },
  SET_DATE_PARAM (state, { start, end }) {
    Vue.set(state, 'dateAsParam', { start, end })
  },
  SET_CROSS_PARAM (state, payload) {
    Vue.set(state, 'paramsCrossPage', payload)
  },
  SET_CURRENT_DATERANGE (state, { start, end }) {
    Vue.set(state, 'start', start)
    Vue.set(state, 'end', end)
  },
  SET_DOMAINLIST (state, { domainList }) {
    const curDomainId = state.domainId
    if (!curDomainId && domainList[0]) {
      Vue.set(state, 'currentDomain', domainList[0])
      Vue.set(state, 'domainId', domainList[0].id)
      Vue.set(state.app, 'dianjingIDList', [])
      Vue.set(state.app, 'dianjingID', 0)
    }
    Vue.set(state, 'domainList', domainList)
  },
  SET_SITE_LIST (state, siteList) {
    Vue.set(state, 'siteList', siteList)
  },
  SET_DIANJINGID (state, dianjingID) {
    Vue.set(state, 'dianjingID', dianjingID)
  },
  SET_DOMAINID (state, { domainId }) {
    Vue.set(state, 'domainId', domainId)
    Vue.set(state.app, 'dianjingIDList', [])
    Vue.set(state.app, 'dianjingID', 0)
  },
  SET_AOTARGET (state, aoTarget) {
    Vue.set(state, 'aoTarget', aoTarget)
  },
  SET_CURRENT_DOMAIN (state, { domain }) {
    Vue.set(state, 'currentDomain', domain)
  },
  FETCH_LOADING: function (state) {
    Vue.set(state, 'loading', true)
  },
  FETCH_SUCCESS: function (state, res) {
    Vue.set(state, 'loading', false)
    Vue.set(state, 'fetchResult', res)
  },
  FETCH_MULT_SUCCESS: function (state, res) {
    Vue.set(state, 'loading', false)
    Vue.set(state, 'fetchMultResult', res)
  },
  SET_CHECKLIST: function (state, { list }) {
    Vue.set(state, 'tableCheckList', list)
  },
  UI_ERROR: (state, errMsg) => {
    Vue.set(state, 'uiError', { errMsg })
  },
  CHART_LOADING: (state, loading) => {
    Vue.set(state, 'chartLoading', loading)
  },
  TABLE_LOADING: (state, loading) => {
    Vue.set(state, 'tableLoading', loading)
  },
  LOADING: (state, loading) => {
    Vue.set(state, 'loading', loading)
  },
  SET_DRAWCHART_CLICK: (state, drawabled) => {
    Vue.set(state, 'drawChartabled', drawabled)
  }
}

// create actions
const actions = {
  SET_CLUSTER_ID (context, id) {
    context.commit('SET_CLUSTER_ID', id)
  },
  SET_MV_ADDSITE (context, status) {
    context.commit('SET_MV_ADDSITE', status)
  },
  SET_START_CROWDVALID (context, status) {
    context.commit('SET_START_CROWDVALID', status)
  },
  SET_DRAWCHART (context, drawabled) {
    context.commit('SET_DRAWCHART_CLICK', drawabled)
  },
  SET_TABLE_CHECKLIST (context, list) {
    context.commit('SET_CHECKLIST', { list })
  },
  SET_CHART_LOADING (context, loading) {
    context.commit('CHART_LOADING', loading)
  },
  SET_TABLE_LOADING (context, loading) {
    context.commit('TABLE_LOADING', loading)
  },
  UI_ERROR (context, errMsg) {
    context.commit('UI_ERROR', errMsg)
  },
  VUE_HTTP (context, promises) {
    context.commit('LOADING')
    return Promise.all(promises)
      .then(responses => {
        let isSuccess = true
        const output = []
        let errMsg = ''
        let errno = ''
        responses.forEach(res => {
          if (isSuccess) {
            isSuccess = res.ok && res.body.errno === 0
            errMsg = res.body.errmsg || res.statusText
            errno = res.body.errno
          }
          output.push(res.body)
        })
        if (!isSuccess) {
          /* eslint-disable no-throw-literal */
          throw { errno: errno, errMsg: errMsg }
        } else {
          if (output.length > 1) {
            return Promise.resolve(output)
          }
          return Promise.resolve(output[0])
        }
      })
      .catch(e => {
        if (!e.errMsg) {
          e.errMsg = '请求失败，请稍后重试。。。'
        }
        context.commit('UI_ERROR', e.errMsg)
        return Promise.resolve(e)
      })
  },
  BASE_FETCH (context, { serviceUrl, query = {}, success, action = 'GET' }) {
    context.commit('FETCH_LOADING')
    action = action.toUpperCase()
    let fetchObj = {}
    if (action === 'GET') {
      fetchObj = Vue.http.get(serviceUrl, { params: query })
    } else {
      fetchObj = Vue.http.post(serviceUrl, { params: query })
    }
    fetchObj.then(r => r.json()).then(
      response => {
        if (!response.errno) {
          context.commit('FETCH_SUCCESS', response)
          success && success(response)
        } else {
          throw { response }
        }
      },
      err => {
        console.log(err)
        // this.$Modal.warn(err.errmsg || '请求失败，请检查网络连接');
      }
    )
  },
  MULT_FETCH (
    context,
    { sumUrl, sumQuery, detailUrl, detailQuery, success, action = 'GET' }
  ) {
    context.commit('FETCH_LOADING')
    action = action.toUpperCase()
    let fetchObj = {}
    if (action === 'GET') {
      fetchObj = Promise.all([
        Vue.http.get(sumUrl, { params: sumQuery }),
        Vue.http.get(detailUrl, { params: detailQuery })
      ])
    } else {
      fetchObj = Promise.all([
        Vue.http.post(sumUrl, { params: sumQuery }),
        Vue.http.post(detailUrl, { params: detailQuery })
      ])
    }
    fetchObj.then(
      ([sumRes, detailRes]) => {
        if (sumRes.status === 200 && detailRes.status === 200) {
          context.commit('FETCH_MULT_SUCCESS', {
            sum: sumRes.data.list,
            detail: detailRes.data
          })
          success && success({ sum: sumRes.data.list, detail: detailRes.data })
        } else {
          const errData = sumRes.data.errmsg ? sumRes.data : detailRes.data
          throw { errData }
        }
      },
      err => {
        console.log(err.data.errmsg)
        // this.$Modal.warn(err.errmsg || '请求失败，请检查网络连接');
      }
    )
  }
}

// getters
const getters = {}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    app: AppModule,
    web: WebModule
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js